export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_ID;
export const COOKIE_CONSENT_COOKIE_NAME = "picter-cookie-consent";
export const COOKIE_VALUES = {
  ALL: "all",
  FUNCTIONAL: "functional",
};

export const UTM_PARAMS_SESSION_STORAGE_KEY = "picter-utm-params";
